<template>
  <v-container grid-list-sm>
    <v-layout>
      <v-flex xs12 md6 offset-sm3>
        <v-card :color="$store.state.sysBackgroundColor">
          <EncabezadoReporte
            :titulo="titulo"
            :accion="accion"
            @ejecutarAccion="ejecutarAccion"
          />
          <v-card-text>
            <v-form ref="form">
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <SelectPuntoVenta
                    :model="itemActivo.Id_PuntoVenta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarPuntoVenta"
                  />
                </v-flex>
                <v-flex xs12 md2 offset-md2>
                  <v-text-field
                    label="Prefijo*"
                    v-model="itemActivo.PrefijoPuntoVenta"
                    :rules="[rules.requerido]"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectModulo
                    :model="itemActivo.Id_Modulo"
                    :rules="[rules.requerido]"
                    @seleccionarItem="cargarModulo"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <SelectTipoComprobante
                    :id_Modulo="itemActivo.Id_Modulo"
                    :model="itemActivo.Id_TipoComprobante"
                    :rules="[rules.requerido]"
                    @seleccionarItem="cargarTipoComprobante"
                  />
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 md8>
                  <FechaRango
                    :fechaDesde="itemActivo.FechaDesde"
                    :fechaHasta="itemActivo.FechaHasta"
                    :rules="[rules.requerido]"
                    @seleccionarItem="seleccionarFecha"
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <PieCrud :loading="loading" />
        </v-card>
      </v-flex>
    </v-layout>
    <Mensaje
      :activo="mensajeActivo"
      :tipo="mensajeTipo"
      :titulo="mensajeTitulo"
      :detalle="mensajeDetalle"
      @ejecutarAccion="ejecutarAccion"
    />
  </v-container>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
import EncabezadoReporte from "@/components/EncabezadoReporte";
import PieCrud from "@/components/PieCrud";
import Mensaje from "@/components/Mensaje";
import FechaRango from "@/components/FechaRango";
import SelectModulo from "@/components/Sistema/SelectModulo";
import SelectTipoComprobante from "@/components/Sistema/SelectTipoComprobante";
import SelectPuntoVenta from "@/components/Sistema/SelectPuntoVenta";
export default {
  name: "ComprobanteListarPorTipoComprobante",
  components: {
    EncabezadoReporte,
    PieCrud,
    Mensaje,
    FechaRango,
    SelectModulo,
    SelectTipoComprobante,
    SelectPuntoVenta
  },
  data() {
    return {
      titulo: "Comprobantes Por Tipo",
      itemVacio: {
        Id_Modulo: 0,
        NombreModulo: "",
        Id_TipoComprobante: 0,
        NombreTipoComprobante: "",
        Id_PuntoVenta: 0,
        PrefijoPuntoVenta: 0,
        FechaDesde: "",
        FechaHasta: ""
      },
      itemActivo: {},
      rules: {
        requerido: v => !!v || "Requerido"
      },
      loading: false,
      mensajeActivo: false,
      mensajeTipo: "",
      mensajeTitulo: "",
      mensajeDetalle: "",
      accion: ""
    };
  },
  created() {
    this.inicializar();
  },
  methods: {
    ejecutarAccion(accion) {
      this.accion = accion;
      switch (accion) {
        case "Imprimir":
        case "ExportarXls":
          if (this.$refs.form.validate()) this.imprimir();
          break;
        case "CancelarError":
          this.mostrarMensaje(false);
          this.ejecutarAccion("Inicializar");
          break;
        case "Inicializar":
          this.$refs.form.resetValidation();
          this.inicializar();
          break;
      }
    },
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    cargarModulo(item) {
      this.itemActivo.Id_Modulo = item.Id_Modulo;
      this.itemActivo.NombreModulo = item.Nombre;
    },
    cargarTipoComprobante(item) {
      this.itemActivo.Id_TipoComprobante = item.Id_TipoComprobante;
      this.itemActivo.NombreTipoComprobante = item.Nombre;
    },
    seleccionarPuntoVenta(item) {
      this.itemActivo.Id_PuntoVenta = item.Id_PuntoVenta;
      this.itemActivo.PrefijoPuntoVenta = item.Prefijo;
    },
    seleccionarFecha(item) {
      this.itemActivo.FechaDesde = item.FechaDesde;
      this.itemActivo.FechaHasta = item.FechaHasta;
    },
    imprimir() {
      switch (this.itemActivo.NombreModulo) {
        case this.$nombreModulo_Venta:
        case this.$nombreModulo_EeSs:
          this.buscarVenta();
          break;
        case this.$nombreModulo_Compra:
          this.buscarCompra();
          break;
        case this.$nombreModulo_Caja:
          this.buscarVale();
          break;
        default:
          this.buscarValeBeneficio();
          break;
      }
    },
    buscarVenta() {
      this.loading = true;
      HttpHelper.getBlob("Venta/ListarPorTipoComprobante", {
        accion: this.accion,
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        id_TipoComprobante: this.itemActivo.Id_TipoComprobante,
        nombreTipoComprobante: this.itemActivo.NombreTipoComprobante,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarCompra() {
      this.loading = true;
      HttpHelper.getBlob("Compra/ListarPorTipoComprobante", {
        accion: this.accion,
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        id_TipoComprobante: this.itemActivo.Id_TipoComprobante,
        nombreTipoComprobante: this.itemActivo.NombreTipoComprobante,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarVale() {
      this.loading = true;
      HttpHelper.getBlob("Vale/ListarPorTipoComprobante", {
        accion: this.accion,
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        id_TipoComprobante: this.itemActivo.Id_TipoComprobante,
        nombreTipoComprobante: this.itemActivo.NombreTipoComprobante,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    buscarValeBeneficio() {
      this.loading = true;
      HttpHelper.getBlob("ValeBeneficio/ListarPorTipoComprobante", {
        accion: this.accion,
        id_PuntoVenta: this.itemActivo.Id_PuntoVenta,
        id_TipoComprobante: this.itemActivo.Id_TipoComprobante,
        nombreTipoComprobante: this.itemActivo.NombreTipoComprobante,
        fechaDesde: this.itemActivo.FechaDesde,
        fechaHasta: this.itemActivo.FechaHasta
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = response.headers["content-disposition"]
            .split(";")[1]
            .split("=")[1]
            .trim();
          link.setAttribute("download", "Reporte_" + fileName);
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(error => {
          this.mostrarError(error);
        });
    },
    mostrarError(error) {
      let detalle =
        error.response == undefined
          ? error
          : error.response.data.ExceptionMessage;
      this.mostrarMensaje(true, "Error", null, detalle);
    },
    mostrarMensaje(activo, tipo, titulo, detalle) {
      if (activo) {
        this.mensajeTipo = tipo;
        this.mensajeTitulo = titulo;
        this.mensajeDetalle = detalle;
      }
      this.mensajeActivo = activo;
    }
  }
};
</script>
